import React, { useCallback, useMemo, useState } from "react";
import { Button, Skeleton } from "antd";
import { UserOutlined, MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { selectUserState } from "../../store/user/selectors";
import { StyledProfileDetails } from "./styles";
import httpClient from "../../api/httpClient";
import { ROUTES } from "../../constant/routes";
import { parseError } from "../../utils/shared";

const ProfileItem = (props) => {
  const { icon, label, children } = props;
  return (
    <div className="profile-item">
      <span className="profile-icon">{icon}</span>
      <div className="profile-content">
        <span className="profile-label">{label}</span>
        <span className="profile-value">{children || "-"}</span>
      </div>
    </div>
  );
};

ProfileItem.displayName = "ProfileItem";

const ProfileDetails = () => {
  const [submitting, setSubmitting] = useState(false);
  const { user, loading } = useSelector(selectUserState);

  const profileItems = useMemo(() => {
    if (!user) return null;

    const { first_name, last_name, email, phone_country_code, phone } = user;

    return [
      {
        icon: <UserOutlined />,
        label: "Name",
        value: `${first_name} ${last_name}`,
      },
      {
        icon: <MailOutlined />,
        label: "Email",
        value: email,
      },
      {
        icon: <PhoneOutlined />,
        label: "Phone",
        value: `${phone_country_code} ${phone}`,
      },
    ];
  }, [user]);

  const onLogout = useCallback(async () => {
    try {
      setSubmitting(true);

      await httpClient.post("logout", {
        refresh_token: httpClient.getRefreshToken(),
      });
    } catch (error) {
      parseError(error, true);
    } finally {
      setSubmitting(false);
      localStorage.clear();
      window.location.href = ROUTES.SIGNIN;
    }
  }, []);

  return (
    <StyledProfileDetails>
      {loading ? (
        <Skeleton active paragraph={{ rows: 4 }} title={false} />
      ) : (
        <>
          {profileItems.map((item, index) => (
            <ProfileItem key={index} icon={item.icon} label={item.label}>
              {item.value}
            </ProfileItem>
          ))}
          <Button
            danger
            disabled={submitting}
            loading={submitting}
            style={{ marginTop: "20px", maxWidth: "400px", width: "100%" }}
            onClick={onLogout}
          >
            Logout
          </Button>
        </>
      )}
    </StyledProfileDetails>
  );
};

export default ProfileDetails;
